import React, { Component } from "react";

class Endbody extends Component {

    render() {
        return(
            <React.Fragment>
                <script type="text/javascript" src="../../assets/js/jquery.min.js"></script>
                <script type="text/javascript" src="../../assets/js/jquery-3.3.1.min.js"></script>
                <script type="text/javascript" src="../../assets/js/bootstrap.min.js"></script>
                <script type="text/javascript" src="../../assets/js/owl.carousel.js"></script>
                <script type="text/javascript" src="../../assets/js/owl.carousel.min.js"></script>
                <script type="text/javascript" src="../../assets/js/calls.js"></script>
            </React.Fragment>
        );
    }
}

export default Endbody;